import createModelStore from "../../utils/createModelStore";
import CarColor from "../../services/CarColor";

const carColors = createModelStore<CarColor.Model, "carColors">("carColors");

export default carColors;
